import HandMove from './src/vue3-hand-mobile.js';
export default HandMove;
